<template>
  <v-chip outlined pill small>
    {{position.IPOS_NAME || ''}}
    <v-icon small right @click="showChoosePositionDialog = true" v-if="mode=='edit'">
      mdi-account-edit
    </v-icon>
    <choosePositionDialog v-model="showChoosePositionDialog" :positionID="position.IPOS_ID" @onPositionSelected="choosePos" @onPositionAdded="onPositionAdded" />
  </v-chip>
</template>

<script>
import choosePositionDialog from '@/components/modules/org/structure/staff/dialogs/choosePositionDialog.vue'
export default {
  props: ['position', 'mode'],
  components: {
    choosePositionDialog
  },
  data () {
    return {
      showChoosePositionDialog: false
    }
  },
  computed: {
  },
  methods: {
    choosePos (val) {
      this.$emit('onPositionSelected', val)
    },
    onPositionAdded (val) {
      this.$emit('onPositionAdded', val)
    }
  }
}
</script>
